export const SELECTORS = {
  CONTAINER: 'js-upgrade-offer',
  LOADING: 'js-upgrade-offer-loading',
  ERROR: 'js-upgrade-offer-error',
  ERROR_TEXT: 'js-upgrade-offer-error-text',
  SUCCESS: 'js-upgrade-offer-success',
  SUCCESS_TEXT: 'js-upgrade-offer-success-text'
};
